import axios from '@/api/config';
const scheduleInfo={
  microTransferClass(data){
    return  axios.post(`${process.env.BASE_URL}/scheduleInfo/microTransferClass`, data);
  },
  transferClass(data){
    return  axios.post(`${process.env.BASE_URL}/scheduleInfo/transferClass`, data);
  },
  suspendClass(data){
    return  axios.post(`${process.env.BASE_URL}/scheduleInfo/suspendClass`, data);
  },
  resumeClass(data){
    return  axios.post(`${process.env.BASE_URL}/scheduleInfo/resumeClass`, data);
  },
  getScheduleInfoListCache(data){
    return  axios.get(`${process.env.BASE_URL}/scheduleInfo/getScheduleInfoListCache`, {params: data});
  },
  batchAddScheduleInfo(data){
    return  axios.get(`${process.env.BASE_URL}/scheduleInfo/batchAddScheduleInfo`, {params: data});
  },
}
export default scheduleInfo



// WEBPACK FOOTER //
// ./src/api/scheduleInfo.js